import React, {useRef} from 'react';
import styled from "styled-components";
import gql from 'graphql-tag';
import {useMutation, useQuery} from "@apollo/client";
import {Button, Card, Elevation, FormGroup, InputGroup, TextArea} from "@blueprintjs/core";
import {useBodyColor, useWindowDimensions} from "../hooks";
import Select from "react-select";
import MobilePage from "../components/MobilePage";
// import SweetAlert from "sweetalert-react";
// import 'sweetalert/dist/sweetalert.css';
import {useHistory} from "react-router";
import moment from "moment";
import ReactStars from "react-stars";
import {Dialog} from "evergreen-ui";

const GET_TEAM_BY_ID = gql`
    query($teamId: Int!) {
        team(id: $teamId) {
            id
            displayName: name(format: WITH_DIVISION_AND_MODIFIER)
            division {
                id
                rank
                name
                
                modifier {
                    id
                    rank
                    name
                }
            }
        }
    }
`

const GET_TEAM_GAMES = gql`
    query($teamId: Int!) {
        
        team(id: $teamId) {
            submittedGameScoreIds
        }
        
        gamesForTeam(id: $teamId) {
            id

            score {
                homeTeamRuns
                awayTeamRuns
            }
            
            createdBy {
                id
                name
            }
            opponent {
                id
                name
            }
            
            isCancelled

            schedulingDetails {
                homeTeam {
                    id
                    displayName: name(format: WITH_DIVISION_AND_MODIFIER)
                }
                awayTeam {
                    id
                    displayName: name(format: WITH_DIVISION_AND_MODIFIER)
                }
                field {
                    id
                    name
                }
                dateTime
            }
            formHistory {
                id
                createdBy {
                    id
                    name
                }
                timeCreated
                approvalStatus

                ... on GameSchedulingForm {
                    gameDateTime
                    gameField {
                        id
                        name
                    }
                    isHomeGameForEnteringTeam
                }

                approvers {
                    team {
                        id
                        name
                    }
                    status
                    statusLastUpdated
                }
            }
            
            primaryUmpire {
                id
                firstName
                lastName
            }

            secondaryUmpire {
                id
                firstName
                lastName
            }
        }
    }
`

const REPORT_GAME_SCORE = gql`
    mutation($gameId: Int!, $data: ReportGameScoreInput!) {
        reportGameScoreNew(gameId: $gameId, data: $data) {
            id
            score {
                homeTeamRuns
                awayTeamRuns
            }
        }
    }
`

const Wrapper = styled.div`
  padding: 12px;
  width: 100%;
`

const SingleScoreInput = ({ teamName, onChange, disabled }) => {

  const { width } = useWindowDimensions()

  const [inputValue, setInputValue] = React.useState('');
  const inputRef = useRef(null)

  const fontSize = width < 700 ? '1.3rem' : '1.5rem'

  const isMobile = width < 700

  return (
    <div
      style={{display: 'flex', justifyContent: 'space-between', flexDirection: isMobile ? 'column' : 'row', paddingTop: '10px'}}
    >
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
        <h3 style={{
          fontSize: fontSize,
          color: teamName ? 'black' : 'grey',
          textAlign: isMobile ? 'center' : 'left',
          marginTop: isMobile ? 0 : undefined, padding: 0
        }}>
          {teamName ?? 'Opponent'}
        </h3>

      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: isMobile ? 'center' : undefined
        }}
      >
        <InputGroup
          inputRef={inputRef}
          placeholder={'#'}
          style={{width: '125px', height: '125px', fontSize: '3rem', textAlign: 'center', lineHeight: '125px', }}
          type={'number'}
          pattern="\d*"
          large
          maxLength={3}
          disabled={disabled}
          value={inputValue}
          onWheel={e => inputRef?.current?.blur()}
          onChange={e => {
            const { value } = e.target

            if (value.length > 3) {
              return
            }

            setInputValue(value)

            if (value === '') {
              onChange(null)
            } else {
              onChange(parseInt(value))
            }
          }}
        />
      </div>
    </div>
  )
}

const FormattedGameChoice = ({ alreadySubmitted, gameDetails }) => {

  const { dateTime, otherTeam, isHomeGame, score } = gameDetails

  const teamDivider = isHomeGame ? 'vs' : '@'

  const {width} = useWindowDimensions()

  const isMobile = width < 700

  let scorePart = ''

  if (score) {
    if (isHomeGame) {
      scorePart = `${score.homeTeamRuns} - ${score.awayTeamRuns}`
    } else {
      scorePart = `${score.awayTeamRuns} - ${score.homeTeamRuns}`
    }
  }

  const didWin = (isHomeGame && (score?.homeTeamRuns > score?.awayTeamRuns)) || (!isHomeGame && (score?.homeTeamRuns < score?.awayTeamRuns))
  const didTie = (score?.homeTeamRuns === score?.awayTeamRuns)

  return (
    <div style={{display: 'flex', justifyContent: 'space-between'}}>
      <p style={{margin: 0, padding: 0}}>
        <span style={{textDecoration: alreadySubmitted ? 'line-through' : undefined}}>
          {moment(dateTime).format('llll')} &nbsp;{teamDivider}&nbsp; {otherTeam}
        </span>
      </p>
      <div style={{width: '10px'}}/>
      {alreadySubmitted &&
        <p style={{color: didTie ? '#F29040' : (didWin ? 'green' : 'red'), margin: 0, padding: 0, fontWeight: 'bold', textAlign: "right", width: isMobile ? '150px' : '250px'}}>{scorePart}</p>
      }
    </div>
  )
}


const ratingNames = ['Awful', 'Bad', 'OK', 'Good', 'Great!']
const RateUmpire = ({ umpire, onRatingChange, style = {} }) => {

  const styles = {
    ...style
  }

  return (
    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%'}}>
      <div style={styles}>
        <h2 style={{textAlign: 'center'}}>{`${umpire.firstName} ${umpire.lastName}`}</h2>
        <div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
          <ReactStars
            count={5}
            half={false}
            onChange={nr => onRatingChange(nr)}
            size={36}
            value={umpire.currentRating}
            color2={'#ffd700'}
          />
        </div>

        <h3 style={{textAlign: 'center', margin: 0, padding: 0}}>{umpire.currentRating !== null ? ratingNames[umpire.currentRating-1] : '-'}</h3>
      </div>
    </div>
  )
}

const RateUmpireLayout = styled.div`
  display: grid;
  
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 20px 1fr;
  
  @media only screen and (min-width: 700px) {
    grid-template-columns: 1fr 20px 1fr;
    grid-template-rows: auto;
  }
`

const RateUmpires = ({ primaryUmpire, secondaryUmpire, onPrimaryUmpireRatingChange, onSecondaryUmpireRatingChange }) => {
  const { width } = useWindowDimensions()

  if (!(primaryUmpire && secondaryUmpire)) {
    return <RateUmpire
      umpire={primaryUmpire ? primaryUmpire : secondaryUmpire}
      onRatingChange={primaryUmpire ? onPrimaryUmpireRatingChange : onSecondaryUmpireRatingChange}
    />
  }

  if (width < 700) {
    return (
      <RateUmpireLayout>
        <RateUmpire
          umpire={primaryUmpire}
          onRatingChange={onPrimaryUmpireRatingChange}
        />
        <div style={{borderBottom: '1px solid grey'}} />
        <RateUmpire
          umpire={secondaryUmpire}
          onRatingChange={onSecondaryUmpireRatingChange}
        />
      </RateUmpireLayout>
    )
  } else {
    return (
      <RateUmpireLayout>
        <RateUmpire
          umpire={primaryUmpire}
          onRatingChange={onPrimaryUmpireRatingChange}
        />
        <div style={{borderRight: '1px solid grey'}} />
        <RateUmpire
          umpire={secondaryUmpire}
          onRatingChange={onSecondaryUmpireRatingChange}
        />
      </RateUmpireLayout>
    )
  }
}

const GameSelect = ({ enteringTeam, onGameChange }) => {

  const { data } = useQuery(GET_TEAM_GAMES, {
    variables: {
      teamId: enteringTeam?.id
    }
  })

  const choices = React.useMemo(() => {
    if (!data) return null

    const { gamesForTeam: games } = data
    const { submittedGameScoreIds } = data.team

    const now = moment()

    const unsortedGames = games
      .filter(game => game.schedulingDetails && !game.isCancelled)
      .map(game => {
        const { id, primaryUmpire, secondaryUmpire, score } = game
        const { dateTime, homeTeam, awayTeam } = game.schedulingDetails

        let otherTeam = homeTeam.displayName

        if (enteringTeam.id === homeTeam.id) {
          otherTeam = awayTeam.displayName
        }

        const alreadySubmitted = submittedGameScoreIds.includes(id)
        const isHomeGame = homeTeam.id === enteringTeam.id

        const gameDetails = {
          dateTime,
          otherTeam,
          isHomeGame,
          score
        }

        return {
          label: <FormattedGameChoice alreadySubmitted={alreadySubmitted} gameDetails={gameDetails} />,
          value: id,
          meta: {id, teamName: otherTeam, isHomeGame, primaryUmpire, secondaryUmpire, dateTime},
          isDisabled: alreadySubmitted || now.isBefore(moment(dateTime)),
          isAlreadySubmitted: alreadySubmitted
        }
      }
    )

    unsortedGames.sort((a, b) => {
      return moment(a.meta.dateTime).isBefore(b.meta.dateTime) ? -1 : 1
    })

    const alreadySubmittedGames = unsortedGames.filter(game => game.isAlreadySubmitted)
    const unsubmittedGames = unsortedGames.filter(game => !game.isAlreadySubmitted)

    return [...unsubmittedGames, ...alreadySubmittedGames]
  }, [enteringTeam.id, data])

  return (
    <div>
      <Select
        options={choices ?? "Loading..."}
        onChange={e => {
          onGameChange(e.meta)
        }}
        isSearchable={false}
        noOptionsMessage={() => 'No Games'}
        blurInputOnSelect={true}
      />
    </div>
  )
}


const ReportScoreComponent = ({ enteringTeam, onSubmit }) => {

  const [reportGameScore] = useMutation(REPORT_GAME_SCORE)

  const [gameDetails, setGameDetails] = React.useState(null);
  const [homeTeamRuns, setHomeTeamRuns] = React.useState(null);
  const [awayTeamRuns, setAwayTeamRuns] = React.useState(null);
  const [primaryUmpireRating, setPrimaryUmpireRating] = React.useState(null);
  const [secondaryUmpireRating, setSecondaryUmpireRating] = React.useState(null);
  const [comments, setComments] = React.useState('');


  const history = useHistory()

  const canSubmit = React.useMemo(() => homeTeamRuns !== null && awayTeamRuns !== null, [homeTeamRuns, awayTeamRuns])
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  React.useEffect(() => {
    setHomeTeamRuns(null)
    setAwayTeamRuns(null)
  }, [gameDetails])

  return (
    <div>
      <Card
        elevation={Elevation.ONE}
      >
        <FormGroup
          label={'Choose Game'}
        >
          {enteringTeam &&
            <GameSelect
              enteringTeam={enteringTeam}
              onGameChange={setGameDetails}
            />
          }
        </FormGroup>
      </Card>

      <div style={{height: '40px'}} />

      <Card
        key={JSON.stringify(gameDetails)}
        elevation={Elevation.ONE}
      >
        <SingleScoreInput
          teamName={enteringTeam?.displayName}
          onChange={gameDetails?.isHomeGame ? setHomeTeamRuns : setAwayTeamRuns}
          disabled={!gameDetails}
        />

        <h1
          style={{
            borderBottom: '1px solid #000',
            lineHeight: '0.1em',
            margin: '30px 0 20px',
            textAlign: 'center'
          }}
        >
          <span style={{padding: '0 10px', background: '#fff'}}>{(gameDetails && !gameDetails?.isHomeGame) ? '@' : 'VS'}</span>
        </h1>

        <SingleScoreInput
          teamName={gameDetails?.teamName}
          onChange={gameDetails?.isHomeGame ? setAwayTeamRuns : setHomeTeamRuns}
          disabled={!gameDetails}
        />
      </Card>

      <div style={{margin: '15px 0'}} />

      {(gameDetails?.primaryUmpire || gameDetails?.secondaryUmpire) &&
        <Card>
          <div>
            <h2 style={{textAlign: 'center', margin: 0, padding: 0, marginBottom: '10px', fontWeight: '400'}}>Rate Umpires</h2>
            <RateUmpires
              primaryUmpire={gameDetails?.primaryUmpire ? {...gameDetails.primaryUmpire, currentRating: primaryUmpireRating} : null}
              onPrimaryUmpireRatingChange={setPrimaryUmpireRating}
              secondaryUmpire={gameDetails?.secondaryUmpire ? {...gameDetails.secondaryUmpire, currentRating: secondaryUmpireRating} : null}
              onSecondaryUmpireRatingChange={setSecondaryUmpireRating}
            />
          </div>
        </Card>
      }

      <div style={{margin: '15px 0'}} />

      <Card>
        <FormGroup
          label={'Comments'}
        >
          <TextArea
            style={{width: '100%', resize: 'vertical'}}
            placeholder={'Game, Umpire, and/or Sportsmanship Comments'}
            growVertically={true}
            value={comments}
            onChange={e => setComments(e.target.value)}
          />
        </FormGroup>
      </Card>

      <div
        style={{
          marginTop: '40px',
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <Button
          intent={'primary'}
          style={{width: '250px'}}
          disabled={!canSubmit || isSubmitting}
          loading={isSubmitting}
          onClick={() => {
            setIsSubmitting(true)
            reportGameScore({
              variables: {
                gameId: gameDetails.id,
                data: {
                  enteringTeamId: enteringTeam.id,
                  homeTeamRuns: homeTeamRuns,
                  awayTeamRuns: awayTeamRuns,
                  primaryUmpireRating,
                  secondaryUmpireRating,
                  comments
                }
              }
            }).then(res => {
              if (res?.data?.reportGameScoreNew) {
                onSubmit({
                  isOpen: true,
                  title: "Score Submitted",
                  message: "Your response was successfully submitted",
                  onClose: () => {
                    history.push(`/home?teamId=${enteringTeam.id}`)
                  }
                })
              } else {
                onSubmit({
                  isOpen: true,
                  title: "Whoops!",
                  message: "Something went wrong. Please refresh the page and try again. If the problem persists contact a league administrator."
                })
              }

              setIsSubmitting(false)
            })
          }}
        >
          Submit Score
        </Button>
      </div>
    </div>
  )
}

export default ({ teamId, clearTeamId }) => {
  const history = useHistory()

  useBodyColor('#ecf7fe')

  const { data } = useQuery(GET_TEAM_BY_ID, {
    variables: {
      teamId
    },
    skip: !teamId
  })

  const [showCompletionPopup, setShowCompletionPopup] = React.useState({isOpen: false, title: "", message: ""});

  return (
    <MobilePage
      usePaddingInTitle={false}
      titleContent={
        <div style={{padding: '12px'}}>
          {/*
          <div
            style={{color: '#669EFF', cursor: 'pointer', borderBottom: '0px solid lightgrey', width: '100%', display: 'flex', justifyContent: 'row', marginBottom: '0px'}}
            onClick={() => {
              clearTeamId()
              history.push({pathname: history.pathname})
            }}
          >
            <Icon icon={'arrow-left'} />
            <h3 style={{display: 'inline-block', lineHeight: '18px', margin: 0, marginLeft: '5px', padding: 0, fontWeight: '600'}}>Choose Another Team</h3>
          </div>
          */}

          <h1 style={{textAlign: 'center', margin: 0, padding: 0}}>Report Score</h1>
          <h2 style={{textAlign: 'center', margin: 0, padding: 0}}>{data?.team?.displayName ?? "..."}</h2>
        </div>
      }
    >
      <Wrapper>
        <ReportScoreComponent
          onSubmit={setShowCompletionPopup}
          enteringTeam={data?.team}
        />

      </Wrapper>

      <Dialog
        isShown={showCompletionPopup.isOpen}
        intent={'success'}
        title={showCompletionPopup?.title ?? ""}
        confirmLabel={'OK'}
        hasCancel={false}
        hasClose={false}
        shouldCloseOnEscapePress={false}
        shouldCloseOnOverlayClick={false}
        onConfirm={() => {
          setShowCompletionPopup({ isOpen: false })
          if (showCompletionPopup.onClose) {
            showCompletionPopup.onClose()
          }
        }}
      >
        {showCompletionPopup.message}
      </Dialog>

      {/*
      <SweetAlert
        show={showCompletionPopup.isOpen}
        confirmButtonColor={'#3085d6'}
        title={showCompletionPopup?.title ?? ""}
        text={showCompletionPopup.message}
        onConfirm={() => {
          setShowCompletionPopup({isOpen: false})
          if (showCompletionPopup.onClose) {
            showCompletionPopup.onClose()
          }
        }}
      />
      */}
    </MobilePage>
  )
}
